import {
  OCP_PROMPT_CARD_CHANGE_REQUESTED,
  OCP_PROMPT_CARD_SELECTED,
  RESET_SELECTED_TOPIC,
  TOPIC_INTENT_CHANGE_FINAL_INTENT_REQUESTED,
  TOPIC_INTENT_FINAL_INTENT_SELECTED,
  TOPIC_INTENT_SEARCH_SHEET_CLOSE,
  TOPIC_INTENT_SEARCH_SHEET_OPEN,
  TOPIC_INTENTS_ERROR,
  TOPIC_INTENTS_REQUESTED,
  TOPIC_INTENTS_SUCCESS,
} from './TopicIntents-Actions';

import {
  PERSONALIZED_FEED_ERROR,
  PERSONALIZED_FEED_REQUESTED,
  PERSONALIZED_FEED_SUCCESS,
} from '../personalizedSection/PersonalizedSection-Actions';

const initialState = {
  isLoading: false,
  isError: false,
  error: null,
  searchSheetOpen: false,
  searchSheetClose: true,
  topicIntents: [],
  priorityIntents: [],
  selectedFinalIntent: {},
  isOcpLoading: true,
  isOcpEnabled: false,
  selectedOcpPrompt: {},
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOPIC_INTENTS_REQUESTED: {
      return { ...state, ...{ isLoading: true } };
    }
    case TOPIC_INTENTS_SUCCESS: {
      return {
        ...state,
        ...{
          topicIntents: action.payload.topicIntents,
          priorityIntents: action.payload.priorityIntents,
          isLoading: false,
        },
      };
    }
    case TOPIC_INTENTS_ERROR: {
      return {
        ...state,
        ...{ isLoading: false, isError: true },
      };
    }
    case TOPIC_INTENT_SEARCH_SHEET_OPEN: {
      return {
        ...state,
        ...{ searchSheetOpen: true, searchSheetClose: false },
      };
    }
    case TOPIC_INTENT_SEARCH_SHEET_CLOSE: {
      return {
        ...state,
        ...{ searchSheetOpen: false, searchSheetClose: true },
      };
    }

    case TOPIC_INTENT_FINAL_INTENT_SELECTED: {
      return {
        ...state,
        selectedFinalIntent: action.payload,
      };
    }

    case TOPIC_INTENT_CHANGE_FINAL_INTENT_REQUESTED: {
      return {
        ...state,
        searchSheetOpen: true,
        searchSheetClose: false,
      };
    }

    case PERSONALIZED_FEED_REQUESTED: {
      return {
        ...state,
        ...{
          isOcpLoading: true,
          ocp: {},
        },
      };
    }

    case PERSONALIZED_FEED_SUCCESS: {
      return {
        ...state,
        ...{
          isOcpLoading: false,
          ocp: action.payload.ocp,
          isOcpEnabled: action.payload.isOcpEnabled,
        },
      };
    }

    case PERSONALIZED_FEED_ERROR: {
      return {
        ...state,
        ...{
          isOcpLoading: false,
          isOcpDataError: true,
          ocp: {},
          ocpDataError: action.payload.message,
        },
      };
    }

    case OCP_PROMPT_CARD_SELECTED: {
      return {
        ...state,
        ...{ selectedOcpPrompt: action.payload.selectedOcpPrompt, selectedFinalIntent: {} },
      };
    }

    case OCP_PROMPT_CARD_CHANGE_REQUESTED: {
      return {
        ...state,
        ...{
          selectedOcpPrompt: {},
          selectedFinalIntent: {},
          searchSheetOpen: true,
          searchSheetClose: false,
        },
      };
    }

    case RESET_SELECTED_TOPIC: {
      return {
        ...state,
        selectedFinalIntent: [],
      };
    }

    default:
      return state;
  }
};

export default Reducer;
